import { Grid, Tooltip} from "@mui/material";

export function getProductassetStruct(){
    return {
        id:{
            name:'id',
            label:'ID',
            value:'',
            error:false,
            errorMessage:'',
            required:false
        },
        
        businessid:{
            name:'businessid',
            label:'Business Id',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'ID'
        },
        title:{
            name:'title',
            label:'title',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'String'
        },
        productid:{
            name:'productid',
            label:'Product Id',
            value:'',
            error:false,
            errorMessage:'You must enter Product Id',
            required:true,
            fieldtype:'ID'
        },
        assetpath:{
            name:'assetpath',
            label:'Asset Path',
            value:'',
            error:false,
            errorMessage:'You must enter Asset Path',
            required:true,
            fieldtype:'string'
        },
        imagetype:{
            name:'imagetype',
            label:'Image Type',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'string'
        },
        designvendorid:{
            name:'designvendorid',
            label:'Design Vendor Id',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'bodynamiclist'
        },
        designvendorname:{
            name:'designvendorname',
            label:'Design Vendor Name',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'string'
        },
        orderedon:{
            name:'orderedon',
            label:'Ordered On',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'date'
        },
        receivedon:{
            name:'receivedon',
            label:'Received On',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'date'
        },
        path:{
            name:'path',
            label:'Path',
            value:'',
            error:false,
            errorMessage:'You must enter Path',
            required:true,
            fieldtype:'string'
        },
        name:{
            name:'name',
            label:'Name',
            value:'',
            error:false,
            errorMessage:'You must enter Name',
            required:true,
            fieldtype:'string'
        },
        assetid:{
            name:'assetid',
            label:'Asset Id',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'number'
        },
        designstatus:{
            name:'designstatus',
            label:'designstatus',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'string'
        },
      }
}

export function getColumns(payload){
  let actionList = [
        
        { field: 'title', headerName: 'title', width:150 },
        { field: 'assetpath', headerName: 'Asset Path', width:150 },
        { field: 'designvendorid', headerName: 'Design Vendor Id', width:150 },
        { field: 'designvendorname', headerName: 'Design Vendor Name', width:150 },
        { field: 'orderedon', headerName: 'Ordered On', width:150 },
        { field: 'receivedon', headerName: 'Received On', width:150 },
        { field: 'path', headerName: 'Path', width:150 },
        { field: 'name', headerName: 'Name', width:150 },
        { field: 'assetid', headerName: 'Asset Id', width:150 },
        { field: 'designstatus', headerName: 'designstatus', width:150 },
  ];
  if (payload!==undefined){
    payload.actionList && payload.actionList.map((actionObj)=>{
    actionList.push(
      {
        field: actionObj.title,
        headerName: actionObj.title,
        sortable: false,
        width:60,
        disableClickEventBubbling: false,
        renderCell: (params) => {
          return (
              <Grid item onClick={()=>{actionObj.callBackMethod(params.row.id)}}>
                <Tooltip title={actionObj.title} sx={{cursor: "pointer"}}>
                  {actionObj.icon}
                </Tooltip>
              </Grid>
          );
        }
      })
    })
  }
  return actionList;
}

export function setData(data, formValues, setFormValues){
   
    setFormValues({
      ['id']:{
        ...formValues['id'],
        value:data.id,
      },
       ['businessid']:{
          ...formValues['businessid'],
          value:data.businessid,
        },['title']:{
          ...formValues['title'],
          value:data.title,
        },['productid']:{
          ...formValues['productid'],
          value:data.productid,
        },['assetpath']:{
          ...formValues['assetpath'],
          value:data.assetpath,
        },['imagetype']:{
          ...formValues['imagetype'],
          value:data.imagetype,
        },['designvendorid']:{
          ...formValues['designvendorid'],
          value:data.designvendorid,
        },['designvendorname']:{
          ...formValues['designvendorname'],
          value:data.designvendorname,
        },['orderedon']:{
          ...formValues['orderedon'],
          value:data.orderedon,
        },['receivedon']:{
          ...formValues['receivedon'],
          value:data.receivedon,
        },['path']:{
          ...formValues['path'],
          value:data.path,
        },['name']:{
          ...formValues['name'],
          value:data.name,
        },['assetid']:{
          ...formValues['assetid'],
          value:data.assetid,
        },['designstatus']:{
          ...formValues['designstatus'],
          value:data.designstatus,
        },
      })
}